import { useTranslation } from 'react-i18next';
import { AlertIcon, CheckIcon } from '@utils/icons';
import type { TradeRowVM } from '../panels/operationsPanels';
import styles from './rightRail.module.css';

export function TradeMatrix({ rows }: { rows: TradeRowVM[] }) {
  const { t } = useTranslation();
  return (
    <section className={styles.panel}>
      <h3 className={styles.panelTitle}>{t('activities.panel.tradeMatrix.title')}</h3>
      <div className={styles.tmTable}>
        <div className={`${styles.tmRow} ${styles.tmHead}`}>
          <span>{t('activities.panel.tradeMatrix.trade')}</span>
          <span className={styles.tmNumCol}>{t('activities.panel.tradeMatrix.onSite')}</span>
          <span className={styles.tmNumCol}>{t('activities.panel.tradeMatrix.planned')}</span>
          <span className={styles.tmCertCol}>{t('activities.panel.tradeMatrix.cert')}</span>
          <span>{t('activities.panel.tradeMatrix.location')}</span>
        </div>
        {rows.map((r) => (
          <div key={r.id} className={styles.tmRow}>
            <span className={styles.tmTrade}>
              <span className={styles.tmTradeName}>{r.trade}</span>
              {r.contractor && <span className={styles.tmContractor}>{r.contractor}</span>}
            </span>
            <span
              className={`${styles.tmNumCol} ${r.onSite < r.planned ? styles.tmNumLow : ''}`}
            >
              {r.onSite}
            </span>
            <span className={`${styles.tmNumCol} ${styles.tmPlanned}`}>{r.planned}</span>
            <span className={styles.tmCertCol}>
              {r.cert ? (
                <span className={styles.tmCertOk} aria-label="certified">
                  <CheckIcon size={15} />
                </span>
              ) : (
                <span className={styles.tmCertBad} aria-label="certification alert">
                  <AlertIcon size={15} />
                </span>
              )}
            </span>
            <span className={styles.tmLoc}>{r.location}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
